export default __webpack_public_path__ + "static/broadcastImg1-6468e35ac30bd9305b4fd3c2888f3834.png";